// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sendEnqiryButton {
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  margin: 0;
  font: inherit;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
  line-height: inherit;
  font-family: Open Sans;
  color: #fff;
  background: #7d3f98;
  font-weight: 700;
  padding: 0 15px 2px;
  text-decoration: none;
  font-size: 16px;
  width: 100px;
  height: 30px !important;
  border-radius: 5px;
  border: 0;
}

.rsw-editor {
  border-color: transparent;
}

.rsw-toolbar {
  border-color: transparent;
}

#subMsg_rte-edit-view > figure > blockquote {
  margin: 1rem;
  padding: 0 20px;
  text-align: left;
  font-family: articulat-cf, sans-serif;
  line-height: 1.5;
  color: #111;
  font-weight: 400;
  font-style: normal;
  font-size: 1em;
  border-left: 0.5px solid rgba(50, 205, 50, 0.832);
  position: relative;
  padding: 20px;
  max-width: calc(100% - 20px);
}

.marT15.marB15.form-control > .e-content {
  display: block;
  width: calc(100% - 12px);
  height: 34px;
  transition: 3.5s all ease-in-out;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  border: transparent;
  margin: 0.875;
  border-image-source: linear-gradient(to left, #d53aa6, #3ad5c8);
  border-image-slice: 1;
  border-width: 5px;
  -webkit-box-shadow: -5px -6px, -1px 0 rgba(12, 179, 198, 0.821);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.marT15.marB15.form-control:hover {
  transition: cubic-bezier(0.6, -0.28, 0.735, 0.045);
  padding: 1.25px;
  display: block;
  outline: 0;
  border-radius: 0.5px;
  box-shadow: 0 0 5px 5px outset #27c5dd;
  border: 10px solid;
  border-image-source: linear-gradient(to left, #3a54d5, #d53a9d);
  transform-style: preserve-3d;
  border-image-slice: 1;
  border-width: 6px;
}

.marT15.marB15.form-control::before {
  content: "";
  position: absolute;
  z-index: -2;
  inset: -5px;
  transform: translate(10px, 8px);
  background: conic-gradient(from 90deg at 40% -25%, #ffd700, #f79d03, #ee6907, #e60a48, #de0d7d, #d610cc, #e309e3, #e600e6, #ff00fb, #a410d6, #ff0048, #ee6907, #f79d03, #ffd700, #ffd700, #ffd700);
  filter: blur(10px);
}

.marT15.marB15.form-control::after {
  content: "";
  position: absolute;
  z-index: -1;
  inset: -2px;
  background: white;
  border: inherit;
  box-shadow: inherit;
}

#subMsgrte-view > div {
  padding: 33px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/SecureMessage.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,6CAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;AACJ;;AAGA;EACI,yBAAA;AAAJ;;AAEA;EACI,yBAAA;AACJ;;AACA;EAEI,YAAA;EACA,eAAA;EACA,gBAAA;EACJ,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EAEA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,4BAAA;AAAA;;AAIA;EACI,cAAA;EACA,wBAAA;EACA,YAAA;EACA,gCAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,+DAAA;EAEA,qBAAA;EACA,iBAAA;EACA,+DAAA;EAGQ,wEAAA;AAFZ;;AAIE;EAEE,kDAAA;EACD,eAAA;EACC,cAAA;EACA,UAAA;EACA,oBAAA;EAEA,sCAAA;EACA,kBAAA;EACA,+DAAA;EACA,4BAAA;EAEA,qBAAA;EACA,iBAAA;AAHJ;;AAME;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;EACA,kMAAA;EAEA,kBAAA;AAJJ;;AAME;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAHJ;;AAMC;EACG,aAAA;AAHJ","sourcesContent":["#sendEnqiryButton {\n    -webkit-text-size-adjust: 100%;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n    margin: 0;\n    font: inherit;\n    overflow: visible;\n    text-transform: none;\n    -webkit-appearance: button;\n    cursor: pointer;\n    line-height: inherit;\n    font-family: Open Sans;\n    color: #fff;\n    background: #7d3f98;\n    font-weight: 700;\n    padding: 0 15px 2px;\n    text-decoration: none;\n    font-size: 16px;\n    width: 100px;\n    height: 30px!important;\n    border-radius: 5px;\n    border: 0;\n}\n\n\n.rsw-editor{\n    border-color:transparent\n}\n.rsw-toolbar{\n    border-color:transparent\n}\n#subMsg_rte-edit-view > figure > blockquote{\n   \n    margin:1rem;\n    padding: 0 20px;\n    text-align: left;\nfont-family: articulat-cf, sans-serif;\nline-height: 1.5;\ncolor: #111;\nfont-weight: 400;\nfont-style: normal;\n\nfont-size: 1em;\nborder-left: 0.5px solid rgba(50, 205, 50, 0.832);\nposition: relative;\npadding: 20px;\nmax-width: calc(100% - 20px);\n\n}\n\n.marT15.marB15.form-control > .e-content{\n    display: block;\n    width: calc(100% - 12px);\n    height: 34px;\n    transition: 3.5s all ease-in-out;\n    font-size: 14px;\n    line-height: 1.42857143;\n    color: #555;\n    background-color: #fff;\n    border: transparent;\n    margin: 0.875;\n    border-image-source: linear-gradient(to left, #d53aa6, #3ad5c8);\n\n    border-image-slice: 1;\n    border-width: 5px;\n    -webkit-box-shadow: -5px -6px, -1px 0 rgba(12, 179, 198, 0.821);\n    -webkit-transition: border-color ease-in-out .15s, -webkit-box-shadow ease-in-out .15s;\n         -o-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n            transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  }\n  .marT15.marB15.form-control:hover{\n\n    transition:cubic-bezier(0.6, -0.28, 0.735, 0.045);\n   padding: 1.25px;\n    display:block;\n    outline: 0;\n    border-radius:0.5px;\n    -webkit-box-shadow: 0 0 5px 5px outset #f2f2f2;\n    box-shadow: 0 0 5px 5px outset #27c5dd;\n    border: 10px solid;\n    border-image-source: linear-gradient(to left, #3a54d5, #d53a9d);\n    transform-style: preserve-3d;\n\n    border-image-slice: 1;\n    border-width: 6px;\n  }\n\n  .marT15.marB15.form-control::before {\n    content: \"\";\n    position: absolute;\n    z-index: -2;\n    inset: -5px;\n    transform: translate(10px, 8px);\n    background: conic-gradient(from 90deg at 40% -25%, #ffd700, #f79d03, #ee6907, #e60a48, #de0d7d, #d610cc, #e309e3, #e600e6, #ff00fb,\n     #a410d6, #ff0048, #ee6907, #f79d03, #ffd700, #ffd700, #ffd700);\n    filter: blur(10px);\n  }\n  .marT15.marB15.form-control::after {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    inset: -2px;\n    background: white;\n    border: inherit;\n    box-shadow: inherit;\n\n  }\n #subMsgrte-view > div {\n    padding: 33px;\n\n  }\n\n  .border-gradient-purple {\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
